import { render, staticRenderFns } from "./tax-certificate-form.vue?vue&type=template&id=66e5ed1e&scoped=true&"
import script from "./tax-certificate-form.vue?vue&type=script&lang=ts&"
export * from "./tax-certificate-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e5ed1e",
  null
  
)

export default component.exports